













import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwInputCheckboxGroup: iwInputCheckboxGroup
    },

    data: function() {
        return {
            uniqueId: uuidv4(),
            checkboxes: [
                {
                    value: "agree",
                    label: "terms_and_conditions_read_with_link"
                },
                {
                    value: "immediate",
                    label: "immediate_publication_waive_withdrawal"
                },
            ],
        };
    },

    computed: {
        ...mapState("AgreementModule", ["termsAndConditions", "immediatePublication"]),

        valueChecked: function(): Array<string> {
            const checked: Array<string> = [];
            if(this.termsAndConditions) {
                checked.push("agree");
            }
            if(this.immediatePublication) {
                checked.push("immediate");
            }
            return checked;
        },
    },

    created: function() {
        this.$store.commit("AgreementModule/termsAndConditions", false);
        this.$store.commit("AgreementModule/immediatePublication", false);
    },


    methods: {
        updateValue: function(selectedValues: Array<string>): void {
            this.$store.commit("AgreementModule/termsAndConditions", selectedValues.includes("agree"));
            this.$store.commit("AgreementModule/immediatePublication", selectedValues.includes("immediate"));
        }
    },
});

